import React from "react";
import ParagraphTag from "../reusebale/Paragraph";
import ButtonTag from '../reusebale/button';
import MyLoader from "../../component/reusebale/myLoader"
const CompletePopup = ({ onDeleteItem, onClose, msg, loading }) => {
  return (
    <main className="w-full h-screen backdrop-blur-sm bg-black/80 fixed inset-0 z-50 flex items-center justify-center">
      <section className="w-[90%] sm:w-[65%] md:w-[50%] lg:w-[40%] xl:w-[20%] bg-texture myshades rounded-[31px] mx-auto">
        <div class="bg-white py-8 lg:py-5 rounded-xl justify-center items-center flex flex-col">

          <ParagraphTag
            content={msg}
            classes=" text-darkColor  text-base pt-2 px-2 text-center"
          />
          {
            loading ? <div className="h-20 flex justify-center items-center"><MyLoader /></div> : <div className="w-[90%]">
              <ButtonTag name='Yes' onSubmit={onDeleteItem} classes=' mt-3 text-base text-center bg-themeColor text-white' />
              <ButtonTag name='No' onSubmit={onClose} classes=' mt-3 text-base text-center text-white bg-dangerColor' />
            </div>
          }

        </div>
      </section>
    </main>
  );
};

export default CompletePopup;
